import axios from "axios";
// import Swal from "sweetalert2";
const state = {};
const mutations = {};
const actions = {
    async enviarCodigo(_, data) {
    let listado = [];
    var config = {
      method: "post",
      url: process.env.VUE_APP_URL_MAIN + "enviarWhastapp",
      headers: {
        "auth-token": sessionStorage.getItem("auth-token"),
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(function (response) {
        let data = response.data;
        if (data.estadoflag) {
          listado = data.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    return listado;
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
